import http from "@/http-common";

/**
 * Service: Sinh Phiếu Thu Nháp Học Phí
 * Base URL: /web/receipt/v1/tuition
 * Lưu ý: idSchool, idCreated, createdBy, idModified, lastModifiedBy KHÔNG cần truyền – BE tự inject từ JWT.
 */

const BASE = "receipt/v1/invoice-draft";

class TuitionDraftInvoiceService {
  /**
   * Sinh danh sách phiếu thu nháp (preview – không lưu DB)
   * POST /web/receipt/v1/tuition/draft-invoices
   *
   * @param {Object} data
   * @param {string}   data.targetType              - "CLASS" | "GROUP"
   * @param {number}   data.month                   - 1–12
   * @param {number}   data.year                    - Năm
   * @param {number}   [data.idClass]               - Bắt buộc khi targetType = CLASS
   * @param {number}   [data.idGroup]               - Bắt buộc khi targetType = GROUP
   * @param {string}   [data.startDate]             - yyyy-MM-dd (null → ngày 1 của tháng)
   * @param {string}   [data.endDate]               - yyyy-MM-dd (null → ngày cuối tháng)
   * @param {number}   [data.collectionTurn]        - Đợt thu
   * @param {string}   [data.descriptionTurn]       - Mô tả đợt thu
   * @param {string[]} [data.listIdRevenueManagement] - UUID khoản thu; [] | null → tất cả
   * @param {number[]} [data.listIdKids]            - ID học sinh; [] | null → tất cả
   * @param {boolean}  [data.monthBeforeOrAfter]    - Lấy điểm danh tháng trước
   * @param {boolean}  [data.allTransaction]        - Tính cả âm lẫn dương tháng trước
   * @param {boolean}  [data.forwardTransaction]    - Chỉ kết chuyển dương
   * @param {boolean}  [data.noForwardTransaction]  - Không kết chuyển
   */
  generateDraftInvoices(data) {
    return http.post(`${BASE}/draft-invoices`, data);
  }

  /**
   * Phát hành phiếu thu chính thức từ danh sách phiếu nháp đã chọn
   * POST /web/receipt/v1/invoice-draft/official-invoices
   *
   * @param {Object} data
   * @param {string} data.targetType - CLASS | GROUP
   * @param {number} data.month
   * @param {number} data.year
   * @param {number} [data.idClass]
   * @param {number} [data.idGroup]
   * @param {string} [data.startDate]
   * @param {string} [data.endDate]
   * @param {number} [data.collectionTurn]
   * @param {string} [data.description]
   * @param {Array<Object>} data.draftInvoices
   */
  createOfficialInvoices(data) {
    return http.post(`${BASE}/official-invoices`, data);
  }

  /**
   * Lấy danh sách học sinh dùng để tạo phiếu thu nháp
   * GET /web/receipt/v1/invoice-draft/kids-in-draft
   *
   * @param {Object} params
   * @param {string} params.status      - Trạng thái học sinh (vd: STUDYING, STUDY_WAIT...)
   * @param {number} params.month      - Tháng
   * @param {number} params.year       - Năm
   * @param {number} params.targetId   - idClass hoặc idGroup
   * @param {string} params.targetType - CLASS | GROUP
   *
   * @returns {Promise<{data: {data: Array<{id: number, name: string, kidCode: string, status: string}>}}>}
   */
  getKidsInDraft(params) {
    return http.get(`${BASE}/kids-in-draft`, { params });
  }

  /**
   * Lấy thông tin bổ sung theo tháng/đợt của học sinh
   * GET /web/receipt/v1/invoice-draft/for-month-and-turn
   *
   * @param {Object} params
   * @param {number} params.month
   * @param {number} params.idStudent
   * @param {string} params.targetType - CLASS | GROUP
   * @param {number} params.turn
   * @param {number} params.year
   */
  getAdditionalInfoForMonthAndTurn(params) {
    return http.get(`${BASE}/for-month-and-turn`, { params });
  }
}

export default new TuitionDraftInvoiceService();

